module.exports = __webpack_public_path__ + "img/image2@2x.2298fdc0.png";